import NotificationPart from 'localization/base/pages/rdevNotifications/NotificationPart';

const notificationType: NotificationPart = {
  internetOutage: 'Internet outage',
  osVersionChanged: 'Operation system version change',
  rdevVersionChanged: 'RDev version change'
};

export default notificationType;
